import { ShipmentLineResetType } from './enums';

export class ShipmentLineReset {
  lineNumber: number;
  resetType: ShipmentLineResetType;

  constructor(lineNumber: number, resetType: ShipmentLineResetType) {
    this.lineNumber = lineNumber;
    this.resetType = resetType; 
  }
}
